import { render, staticRenderFns } from "./BaitulmalEdit.vue?vue&type=template&id=7d334f46"
import script from "./BaitulmalEdit.vue?vue&type=script&lang=js"
export * from "./BaitulmalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports